import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { LanguagePage } from './language/LanguagePage';
import { useKioskConfiguration } from '../contexts/kioskConfiguration/KioskConfigurationContext';
import { getRoutes } from '../contexts/kioskConfiguration/elementsContainer';
import useLanguage from '../contexts/language/LanguageContext';
import { RootState } from '../store/store';

export type RouteConfig = {
  path: string;
  component: React.ReactNode;
}

const routesDefault: RouteConfig[] = [
  {
    path: '/',
    component: <LanguagePage />,
  },
];


export const Router = (): React.ReactElement => {
  const selectedPage = useSelector((state: RootState) => state.app.selectedPage)
  const [routes, setRoutes] = useState<RouteConfig[]>([
    ...routesDefault,
  ]);
  const kioskConfigurationContext = useKioskConfiguration()
  const languageContext = useLanguage()
  const selectedLanguageConfig = kioskConfigurationContext
    .kioskConfiguration
    .languages
    .find((l) => l.code === languageContext.language)
  const translations = selectedLanguageConfig
    ? selectedLanguageConfig.translations
    : kioskConfigurationContext.kioskConfiguration.languages[0].translations

  useEffect(() => {
    const dynamicRoutes = getRoutes(kioskConfigurationContext.kioskConfiguration.pages, translations)
    setRoutes([...routesDefault].concat(dynamicRoutes))
  }, [kioskConfigurationContext.kioskConfiguration, translations]);

  const component = routes.find(route => route.path === selectedPage)?.component
  if (component) {
    return <>{component}</>
  }

  return <>Not found</>
}
